/**
 * @generated SignedSource<<ede6d6e5db7c9fa94871dd6b683313f4>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommonSpaceNavigationContent_space$data = {
  readonly didContainUserContent: boolean;
  readonly homepage: {
    readonly id: string | null;
  } | null;
  readonly id: string | null;
  readonly key: string | null;
  readonly operations: ReadonlyArray<{
    readonly operation: string | null;
    readonly targetType: string | null;
  } | null> | null;
  readonly " $fragmentType": "CommonSpaceNavigationContent_space";
};
export type CommonSpaceNavigationContent_space$key = {
  readonly " $data"?: CommonSpaceNavigationContent_space$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommonSpaceNavigationContent_space">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommonSpaceNavigationContent_space",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "concreteType": "Content",
      "kind": "LinkedField",
      "name": "homepage",
      "plural": false,
      "selections": [
        (v0/*: any*/)
      ]
    },
    {
      "concreteType": "OperationCheckResult",
      "kind": "LinkedField",
      "name": "operations",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "operation"
        },
        {
          "kind": "ScalarField",
          "name": "targetType"
        }
      ]
    },
    {
      "kind": "ScalarField",
      "name": "didContainUserContent"
    }
  ],
  "type": "Space"
};
})();

(node as any).hash = "e9bf4d4cc1e33aa7f52ec90a28fb1edd";

export default node;
